import { User, CreditCard, Landmark, MapPin } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const BusinessBankSection = () => {
  const { formData, isEditing, renderInput } = useProfile();

  return (
    <div className="pt-2">
      <div className="border-b border-slate-100 pb-2.5 mb-4">
        <h2 className="font-semibold text-slate-900 text-base">Bank details</h2>
        <p className="text-xs text-slate-500 mt-0.5 font-normal">Manage your payout and bank accounts</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {renderInput("Account Holder Name", "account_holder_name", formData.account_holder_name || '', "text", !isEditing, User, false, true)}
        {renderInput("Account Number", "account_number", formData.account_number || '', "text", !isEditing, CreditCard, false, true)}
        {renderInput("IFSC Code", "ifsc_code", formData.ifsc_code || '', "text", !isEditing, Landmark, false, true)}
        {renderInput("Branch Name", "branch", formData.branch || '', "text", !isEditing, MapPin)}
      </div>
    </div>
  );
};

export default BusinessBankSection;
